import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M21.5294 7.03039L10.383 18.1768C9.89481 18.665 9.10335 18.665 8.6152 18.1768L1.96875 11.5304L3.02941 10.4697L9.49908 16.9394L20.4688 5.96973L21.5294 7.03039Z",
    fill: "#EE4D2D",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
export default SvgComponent;